import {
  getPathMatch,
  interpolatePathParams,
  joinRouteMatchPath,
  joinRouteMatchUrl
} from '@futrli/shared-services/path/path';
import { ROUTE_PARAMS, ROUTES } from '@futrli/shared-services/app-core/constants';

// Workspaces route (/workspaces)

export const getWorkspacesRoutePath = (): string => {
  return ROUTES.WORKSPACES_ROUTE;
};

export const getWorkspacesUrl = (): string => {
  return joinRouteMatchUrl('', ROUTES.WORKSPACES_ROUTE);
};

export const matchWorkspacesRoutePath = (pathname: string, isExact = false) => {
  const routePath = getWorkspacesRoutePath();
  return getPathMatch(pathname, routePath, isExact);
};

// Workspace route (/workspaces/:workspaceId)

export type WorkspaceTab = 'consolidations' | 'organisations' | 'users';

export type WorkspaceListingTab = Exclude<WorkspaceTab, 'users'>;

export const getWorkspaceRoutePath = (tab?: WorkspaceTab): string => {
  const basePath = joinRouteMatchPath(getWorkspacesRoutePath(), ROUTES.WORKSPACE_BY_ID_ROUTE);
  if (tab === 'organisations') {
    return joinRouteMatchPath(basePath, ROUTES.ORGANISATIONS_ROUTE, ROUTES.ORGANISATIONS_ROUTE);
  }
  if (tab === 'consolidations') {
    return joinRouteMatchPath(basePath, ROUTES.ORGANISATIONS_ROUTE, ROUTES.CONSOLIDATIONS_ROUTE);
  }
  if (tab === 'users') {
    return joinRouteMatchPath(basePath, ROUTES.USERS_ROUTE);
  }
  return basePath;
};

export const getWorkspaceUrl = (workspaceId: string, tab?: WorkspaceTab): string => {
  return interpolatePathParams(getWorkspaceRoutePath(tab), {
    [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId
  });
};

export const getWorkspaceListingRoutePath = (tab?: WorkspaceListingTab): string => {
  const basePath = joinRouteMatchPath(getWorkspaceRoutePath(), ROUTES.ORGANISATIONS_ROUTE);

  return tab ? getWorkspaceRoutePath(tab) : basePath;
};

export const getWorkspaceListingUrl = (workspaceId: string, tab?: WorkspaceListingTab): string => {
  return interpolatePathParams(getWorkspaceListingRoutePath(tab), {
    [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId
  });
};

export const matchWorkspaceConsolidationsListingRoutePath = (pathname: string) => {
  const legacyConsolidationsPath = joinRouteMatchPath(
    getWorkspaceRoutePath(),
    ROUTES.CONSOLIDATIONS_ROUTE
  );

  return (
    getPathMatch(pathname, getWorkspaceListingRoutePath('consolidations'), true) ||
    getPathMatch(pathname, legacyConsolidationsPath, true)
  );
};

export const matchWorkspaceRoutePath = (pathname: string, isExact = false) => {
  const legacyConsolidationsPath = joinRouteMatchPath(
    getWorkspaceRoutePath(),
    ROUTES.CONSOLIDATIONS_ROUTE
  );

  return (
    getPathMatch(pathname, getWorkspaceRoutePath(), isExact) ||
    getPathMatch(pathname, getWorkspaceRoutePath('organisations'), isExact) ||
    getPathMatch(pathname, getWorkspaceRoutePath('consolidations'), isExact) ||
    getPathMatch(pathname, getWorkspaceRoutePath('users'), isExact) ||
    getPathMatch(pathname, getWorkspaceListingRoutePath(), isExact) ||
    getPathMatch(pathname, legacyConsolidationsPath, isExact)
  );
};

// Organisation route (/workspaces/:workspaceId/organisations/:organisationId or /workspaces/:workspaceId/consolidations/:organisationId)

export const getOrganisationRoutePath = (): string => {
  return joinRouteMatchPath(getWorkspaceRoutePath(), ROUTES.ORGANISATIONS_ROUTE, ROUTES.ORGANISATION_BY_ID_ROUTE);
};

export const getOrganisationUrl = (workspaceId: string, organisationId: string): string => {
  return interpolatePathParams(getOrganisationRoutePath(), {
    [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId,
    [ROUTE_PARAMS.ORGANISATION_ID]: organisationId
  });
};

export const matchOrganisationRoutePath = (pathname: string, isExact = false) => {
  const routePath = getOrganisationRoutePath();
  return getPathMatch(pathname, routePath, isExact);
};

// Consolidation route (/workspaces/:workspaceId/consolidations/:organisationId

export const getConsolidationRoutePath = (): string => {
  return joinRouteMatchPath(getWorkspaceRoutePath(), ROUTES.CONSOLIDATIONS_ROUTE, ROUTES.CONSOLIDATION_BY_ID);
};

export const getConsolidationUrl = (workspaceId: string, organisationId: string): string => {
  return interpolatePathParams(getConsolidationRoutePath(), {
    [ROUTE_PARAMS.WORKSPACE_ID]: workspaceId,
    [ROUTE_PARAMS.ORGANISATION_ID]: organisationId
  });
};

export const matchConsolidationRoutePath = (pathname: string, isExact = false) => {
  const routePath = getConsolidationRoutePath();
  return getPathMatch(pathname, routePath, isExact);
};
